<section class="dynamic-form-help">
    <div class="dynamic-form-help__header">
        <h2 class="dynamic-form-help__title">{{ 'FORM.HELP.TITLE' | translate }}</h2>
        <p class="dynamic-form-help__subtitle">{{ 'FORM.HELP.SUBTITLE' | translate }}</p>
    </div>
    <tec-tile type="default" styling="default" class="dynamic-form-help__tile">
        <div class="dynamic-form-help__tips">
            <div class="dynamic-form-help__tip">
                <pwcs-inline-svg
                    class="dynamic-form-help__tip-icon"
                    src="assets/images/form-help-pending-check.svg"
                    idSuffix="form-help-pending-check"
                />
                <div class="dynamic-form-help__tip-text">
                    <p class="dynamic-form-help__tip-title">{{ 'FORM.HELP.TIP_1_TITLE' | translate }}</p>
                    <p class="dynamic-form-help__tip-description">{{ 'FORM.HELP.TIP_1_DESCRIPTION' | translate }}</p>
                </div>
            </div>
            <tec-divider />
            <div class="dynamic-form-help__tip">
                <pwcs-inline-svg
                    class="dynamic-form-help__tip-icon"
                    src="assets/images/form-help-capture-popup.svg"
                    idSuffix="form-help-capture-popup"
                />
                <div class="dynamic-form-help__tip-text">
                    <p class="dynamic-form-help__tip-title">{{ 'FORM.HELP.TIP_2_TITLE' | translate }}</p>
                    <p class="dynamic-form-help__tip-description">{{ 'FORM.HELP.TIP_2_DESCRIPTION' | translate }}</p>
                </div>
            </div>
            <tec-divider />
            <div class="dynamic-form-help__tip">
                <pwcs-inline-svg
                    class="dynamic-form-help__tip-icon"
                    src="assets/images/form-help-text.svg"
                    idSuffix="form-help-text"
                />
                <div class="dynamic-form-help__tip-text">
                    <p class="dynamic-form-help__tip-title">{{ 'FORM.HELP.TIP_3_TITLE' | translate }}</p>
                    <p class="dynamic-form-help__tip-description">{{ 'FORM.HELP.TIP_3_DESCRIPTION' | translate }}</p>
                </div>
            </div>
        </div>
    </tec-tile>
</section>
